import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import ToolTip from 'design-system/ToolTip';
import Squircle from 'design-system/Squircle';
import { Spacer } from 'design-system/Spacer';
import RadioButton from 'design-system/RadioButton';
import useColors from 'hooks/useColors';
const ChartTypeSelectRow = ({ icon, title, isSelected, onSelect, toolTipDesc }) => {
    const colors = useColors();
    return (<TouchableHighlight hoverOnLight onPress={onSelect} underlayColor={colors.background.underlay}>
      <View style={styles.container}>
        <RadioButton type="single" isChecked={isSelected}/>
        <Spacer w={16}/>
        <Squircle color={colors.background.dark}>{icon}</Squircle>
        <Spacer w={16}/>
        <Text Text-16>{title}</Text>
        <Spacer w={8}/>
        <ToolTip title={title} subtitle={toolTipDesc}/>
      </View>
    </TouchableHighlight>);
};
export default ChartTypeSelectRow;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        padding: rem(16),
    },
});
